module.exports = new __parcel__URL__("EthLogo.b15259c3.svg").toString();